// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__ky05J","col":"CardReaderDesc_col__4iSDH","label":"CardReaderDesc_label__1-akf"};